var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 983 823",
    width: 983,
    height: 823,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#dd2c2c}.b{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m854.4 823h-725.2c-101.5 0-162.9-112.2-108.1-197.7l362.6-565.7c50.5-78.9 165.7-78.9 216.2 0l362.6 565.7c54.8 85.5-6.6 197.7-108.1 197.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m557.7 73.7l362.5 565.8c16.4 25.5 17.5 56.7 2.9 83.3-14.5 26.7-41.3 42.6-71.7 42.6h-725.2c-30.3 0-57.2-15.9-71.7-42.6-14.6-26.6-13.5-57.8 2.9-83.3l362.6-565.8c15.3-23.9 40.4-37.7 68.8-37.7 28.4 0 53.5 13.8 68.9 37.7zm-118.1 12.6l-362.6 565.8c-11.7 18.2-12.5 40.5-2.1 59.6 10.4 19 29.6 30.4 51.3 30.4h725.2c21.7 0 40.9-11.4 51.3-30.4 10.4-19.1 9.6-41.4-2.1-59.6l-362.6-565.8c-11.1-17.4-28.6-26.9-49.2-26.9-20.6 0-38.1 9.5-49.2 26.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m494.5 538.8h-11.4c-4.9 0-9-3.9-9.4-8.8l-24-322.9c-0.4-5.5 4-10.1 9.5-10.1h59.3c5.5 0 9.8 4.6 9.4 10.1l-24 322.9c-0.4 4.9-4.5 8.8-9.4 8.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m525.6 631.6c0 20.3-16.5 36.8-36.8 36.8-20.3 0-36.8-16.5-36.8-36.8 0-20.3 16.5-36.8 36.8-36.8 20.3 0 36.8 16.5 36.8 36.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.229f33c3532d66a4080a8149efedf410.svg";
export { ForwardRef as ReactComponent };